export { default } from './Pagination';


//////////////////
// WEBPACK FOOTER
// ./~/rc-pagination/es/index.js
// module id = 1554
// module chunks = 14